import { render } from "./index.vue?vue&type=template&id=7abfe4cb"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/user-invitation-item/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7abfe4cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7abfe4cb', __exports__)) {
    api.reload('7abfe4cb', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7abfe4cb", () => {
    api.rerender('7abfe4cb', render)
  })

}


export default __exports__